<template>
  <v-card>
    <v-card-title primary-title>
      Ta bort kategori: {{ categoryGroups[uuid].name }}
    </v-card-title>

    <v-card-text>
      Är du säker på att du vill ta bort kategorin?
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn text @click="onClose">
        Avbryt
      </v-btn>
      <v-btn type="submit" color="error" text @click="onConfirm">
        Ta bort
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import DELETE_CATEGORY_GROUP from '@/gql/categoryGroups/mutations/DeleteCategoryGroup.gql'
import { get } from 'vuex-pathify'

export default {
  name: 'MasterdataCategoriesDelete',

  props: {
    uuid: String,
  },

  computed: {
    categoryGroups: get('categoryGroups/data'),
  },

  methods: {
    async onConfirm() {
      this.deleteCategoryGroup()
      this.onClose()
    },

    onClose() {
      this.$emit('close')
    },

    deleteCategoryGroup() {
      return this.$apollo.mutate({
        mutation: DELETE_CATEGORY_GROUP,
        variables: {
          uuid: this.uuid,
        },

        update: () => {
          const updatedCategoryGroups = Object.values(this.categoryGroups)
            .filter(x => x.uuid !== this.uuid)
            .reduce((a, b) => {
              a[b.uuid] = b
              return a
            }, {})
          this.$store.set('categoryGroups/data', updatedCategoryGroups)
        },
      })
    },
  },
}
</script>
